import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

/**
 * Inline error banner for forms / modals.
 * Use with the `apiErrorMessage()` / `applyApiErrorsToForm()` helpers.
 */
export default function ApiErrorBanner({ message, onDismiss }) {
  if (!message) return null;
  return (
    <div className="api-error-banner" role="alert">
      <AlertTriangle size={16} className="api-error-banner-icon" />
      <span className="api-error-banner-text">{message}</span>
      {onDismiss && (
        <button type="button" className="api-error-banner-close" onClick={onDismiss} aria-label="Dismiss">
          <X size={14} />
        </button>
      )}
    </div>
  );
}
